import React, { useState, useContext, useEffect } from "react";
import "../Styles.css";
import "./createuser.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/list/FormList.css";
import "../../../ui-styles/tabStyles/HztlTabStyles.css";
import 'react-phone-number-input/style.css';

import { LangCtx, RoleCtx, PayLoadCtx } from "../../../lib/context";
import CreateClinicForm from "./components/CreateClinicForm";
import CreateDoctorForm from "./components/CreateDoctorForm";
import CreatePatientForm from "./components/CreatePatientForm";
// import CreateClinicAdminForm from "./components/CreateAdminForm";
import { useLocation } from 'react-router-dom';
// import ServerDisconnected from "../../common/ServerDisconnected";
// import SessionExpired from "../../common/SessionExpired";


const CreateUsers = (props) => {
    const { l } = useContext(LangCtx);
    const { role } = useContext(RoleCtx);
    const { payload } = useContext(PayLoadCtx);

    const querytTerm = new URLSearchParams(useLocation().search).values;
    const caId = new URLSearchParams(useLocation().search).get('caId');
    const cId = new URLSearchParams(useLocation().search).get('cId');
    const dId = new URLSearchParams(useLocation().search).get('dId');
    const pId = new URLSearchParams(useLocation().search).get('pId');
    const [current, setTab] = useState((role === "CA" || role === "SA") ? "CC" : "CP");

    useEffect(
        () => {
            if (dId || dId === '') {
                setTab("CD");
            }
            else if (pId || pId === '') {
                setTab("CP");
            } else if (cId || cId === '') {
                setTab("CC");
            } else if (caId || caId === '') {
                setTab("CA");
            } else if (role === "SA") {
                setTab("CA");
            }
        }, [cId, dId, pId, caId, role])

    return (
        <>
        {/* <ServerDisconnected /> */}
        {/* <SessionExpired /> */}
        <div className="baseContainer pos-rel">
            <div className="hdngTopCol colBlock">
                <div className="hdngTopBox etcPdng">
                    <h2 className="topHdngTxt">{querytTerm ? (`${l.crt_upd} ${l.user}`) : `${l.crt_new_usr}`}</h2>
                </div>
                <div className="formCol">
                    <div className="formParaRow">
                        <p className="pTxt">{querytTerm ? `${l.crt_upd}` : `${l.create}`} {l.crt_user_desc} </p>
                    </div>
                </div>
                <div className="tabCol">
                    <div className="row hndlpdn08">
                        {/* {role === "SA" && <div className={current === "CA" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("CA")}>
                            <span>{caId && caId !== "" ? `${l.upd_clinic}` : `${l.clinic_admin}`}</span>
                        </div>} */}
                        {(role === "SA" || role === "CA") && <div className={current === "CC" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("CC")}>
                            <span>{cId && cId !== "" ? `${l.upd_clinic}` : `${l.clinic}`}</span>
                        </div>}
                        {(role === "CA" || role === "C") && <div className={current === "CP" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("CP")}>
                            <span>{pId && pId !== "" ? `${l.update_pat}` : `${l.patient}`}</span>
                        </div>}
                        {(role === "SA" || role === "CA" || role === "C") && <div className={current === "CD" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("CD")}>
                            <span>{dId && dId !== "" ? `${l.upd_doc}` : `${l.doctor}`}</span>
                        </div>}
                    </div>
                </div>
            </div>
            {/* {current === "CA" && <CreateClinicAdminForm active={current} caId={caId} l={l} />} */}
            {current === "CC" && <CreateClinicForm active={current} cId={cId} role={role} l={l} userId={payload.userId} />}
            {current === "CD" && <CreateDoctorForm active={current} dId={dId} role={role} l={l} userId={payload.userId} />}
            {current === "CP" && <CreatePatientForm active={current} pId={pId} role={role} l={l} userId={payload.userId} />}

        </div>
        </>
    )
}

export default CreateUsers;
